/* Soporifik · fiche produit : barre d'achat fixe sur téléphone, visible quand le vrai bouton sort de l'écran.
   Elle recopie prix, texte et état du vrai bouton, puis clique dessus. */
function spkBarreAchat() {
  const barre = document.querySelector('[data-spk-barre-achat]');
  if (!barre || barre.dataset.pret || !('IntersectionObserver' in window)) return;
  barre.dataset.pret = '1';

  const section = barre.dataset.section;
  const bouton = barre.querySelector('[data-spk-barre-btn]');
  const prix = barre.querySelector('[data-spk-barre-prix]');
  const vraiBouton = () => document.getElementById(`ProductSubmitButton-${section}`);
  const vraiPrix = () => document.getElementById(`price-${section}`);

  const recopier = () => {
    const source = vraiBouton();
    if (source) {
      bouton.disabled = source.disabled;
      const texte = source.querySelector('span');
      if (texte) bouton.textContent = texte.textContent.trim();
    }
    const montant = vraiPrix()?.querySelector('.price--on-sale .price-item--sale, .price-item--regular');
    if (montant) prix.textContent = montant.textContent.trim();
  };

  const montrer = (oui) => {
    if (!barre.isConnected) return;
    barre.hidden = !oui;
    document.body.classList.toggle('spk-barre-achat-visible', oui);
  };

  let observateur;
  const observer = () => {
    observateur?.disconnect();
    const source = vraiBouton();
    if (!source) return;
    observateur = new IntersectionObserver(([entree]) => {
      montrer(!entree.isIntersecting);
    });
    observateur.observe(source);
    recopier();
  };

  bouton.addEventListener('click', () => vraiBouton()?.click());

  // Dawn remplace le prix et le bouton quand la variante change.
  const fiche = document.querySelector('product-info');
  if (fiche) {
    new MutationObserver(() => {
      if (!vraiBouton()?.isConnected || !observateur) observer();
      recopier();
    }).observe(fiche, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  }

  observer();
}

spkBarreAchat();
// L'éditeur de thème remplace la section sans relancer ce fichier.
document.addEventListener('shopify:section:load', spkBarreAchat);
